export default __webpack_public_path__ + "static/illustration-triangles-d75a20f3c042e3ec8249263235941486.svg";